import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // null = checking, false = unauthenticated, object = user
    const [user, setUser] = useState(null);

    const bootstrap = useCallback(async () => {
        const token = localStorage.getItem("hg_token");
        if (!token) {
            setUser(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("hg_token");
            localStorage.removeItem("hg_email");
            setUser(false);
        }
    }, []);

    useEffect(() => {
        bootstrap();
    }, [bootstrap]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("hg_token", data.token);
        localStorage.setItem("hg_email", data.email);
        setUser({ email: data.email, role: "admin" });
        return data;
    };

    const logout = () => {
        localStorage.removeItem("hg_token");
        localStorage.removeItem("hg_email");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
};
